import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandlerService } from '../services/shared/error-handler/error-handler.service';
import { HelperService } from '../services/shared/helper/helper.service';
import { LoaderService } from '../services/shared/loader/loader.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class CoreInterceptor implements HttpInterceptor {

    constructor(private _helper: HelperService, private _errService: ErrorHandlerService, private _loaderService: LoaderService, private _toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this._toastr.clear();
        this._loaderService.pushRequest();
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ` + this._helper.token.get()
            },
            url: environment.host + request.url
        });
        return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                this._loaderService.pullRequest();
            }
        }, err => {
            if (err instanceof HttpErrorResponse) {
                this._loaderService.pullRequest();
                console.log('error from interceptor : ', err);
                this._errService.pushError(err);
            }
        }));
    }
}